import { Injectable, signal } from '@angular/core';

import type { ColorScheme } from '#/app/shared/domain/ui/color-scheme.model';

@Injectable({ providedIn: 'root' })
export class ColorSchemeContext {
  readonly #override = signal<ColorScheme | undefined>(undefined);

  readonly override = this.#override.asReadonly();

  setOverride(colorScheme: ColorScheme | undefined) {
    this.#override.set(colorScheme);
  }
}
